 import lang from '@/lang/middleware/about';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('description');
  const title = store.$i18n.t('team.title');
  store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
  store.commit('pageContent/setHead', { description, title });
};
